import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";
import Circle from "./supporter_circle";

export default createReactClass({
  displayName: "Root",
  propTypes: {
    supporterCircles: PropTypes.array.isRequired,
  },
  render() {
    if (this.props.supporterCircles.length === 0) {
      return "";
    }
    const supporterCircles = this.props.supporterCircles.map(function(circle) {
      return <Circle circle={circle} key={circle.id} />;
    });
    return (
      <div className="mt50 mb50">
        <h2 className="font-size-28">
          <i className="fas fa-hands" /> このサークルのサポーター
        </h2>
        <div className="touch-wrap">
          <div className="touch">{supporterCircles}</div>
        </div>
      </div>
    );
  },
});
